import api from "../../client";
import { AccountDetailResponseData } from "../../types/account";

export const enableAccountRequest = async (
  uuid: string | undefined,
): Promise<AccountDetailResponseData> => {
  const { data } = await api.put<AccountDetailResponseData>(
    `/account/${uuid}/enable`,
    {},
  );

  return data;
};
